import { Component, OnInit } from '@angular/core';
import { MasterService,ClassroomService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-managevoters',
  templateUrl: './managevoters.component.html',
  styleUrls: ['./managevoters.component.scss'],
   providers:[MasterService,ClassroomService]
})
export class ManagevotersComponent implements OnInit {

 
   modalOptions:NgbModalOptions;
   private modalRef: NgbModalRef;
     sections:any=[];
     classes:any=[];
     arrstf:any=[];
     arrstudent:any=[];
     arrdept:any=[];
     fmodel:any={clid:'0',secid:'0',crid:'0',boothid:'0'};
     arrrepdata:any=[];
     arrper:any=[];
     arrashead:any=[];
     arrcourse:any=[];
     arrpost:any=[];
     arrastype:any=[];
     arrastype1:any=[];
     dropdownList = [];
     selectedItems = [];
     arrstflst:any=[];
     btntype:any='';
     oprtype:any='';
     objcan:any={};
     tabledata: any = {};
     rcremarks='';
     fileToUpload: File = null;
     arrcat:any=[{name:'Board'},{name:'Competitive'}];
     dropdownSettings:IDropdownSettings = {singleSelection: false,
       idField: 'stuid',
       textField: 'stunm',
       selectAllText: 'Select All',
       unSelectAllText: 'UnSelect All',
       itemsShowLimit: 0,
       allowSearchFilter: true};
 
 fData: FormData = new FormData;
     constructor(private http: HttpClient,private aservice:ClassroomService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }
   
     ngOnInit(): void {
      
       this.mascourse();
    this.getposts();
       //this.subjects();
       this.fmodel.attdt=this.mservice.getdatetoday();
       this.fmodel.frtime=this.mservice.getcurenttime();
       this.fmodel.totime=this.mservice.getcurenttime();
       
      
     }
   
     
     masclass() {
       // this.mservice.classmasterrolewise(0,this.fmodel.crid,0,'class')
         this.mservice.masclass()
           .subscribe(
           resultArray => {
               console.log('getdashcounts', resultArray);
               this.classes = resultArray;
              //  this.fmodel.clid=resultArray[0].clid;
               this.massection();
             //  this.masperiod();
               
              
           },
           error => console.log("Error :: " + error)
           )
     }
 
     getvotersboothwise() {
       this.aservice.getvotersboothwise(this.fmodel.crid,this.fmodel.clid,this.fmodel.secid,this.fmodel.boothid)
           .subscribe(
           resultArray => {
               console.log('getdashcounts', resultArray);
 
               
               this.arrrepdata = resultArray;
              
               
              
           },
           error => console.log("Error :: " + error)
           )
     }
 
     
     massection() {
       // this.mservice.sectionsrolewise(0,this.fmodel.crid,this.fmodel.clid,'section')
        this.mservice.massection()
           .subscribe(
           resultArray => {
               console.log('getdashcounts', resultArray);
               this.sections = resultArray;
              //  this.fmodel.secid=resultArray[0].scid;
              // this.masasshead();
              // this.getstudentsdata("voterstu");
           },
           error => console.log("Error :: " + error)
           )
     }
 
 
   
  

   
     
   
 
 
       Savercremarks(obj) {
         var objpost={asid:obj.assid,stuid:obj.stuid,rcremarks:this.rcremarks};
         this.aservice.Savercremarks(objpost)
           .subscribe(result => {
             console.log('ret-loop', result);
             alert(result.message);
             //this.Getsel_sp_masassmodel();
           }, error =>
             alert('error in connection')
           );
       }
   
     
       mascourse() {
         this.mservice.mascourse()
             .subscribe(
             resultArray => {
                 console.log('getdashcounts', resultArray);
                 this.arrcourse = resultArray;
                //  this.fmodel.crid=resultArray[0].crid;
                 this.masclass();
                 //this.fmodel1.crid=resultArray[0].crid;
             },
             error => console.log("Error :: " + error)
             )
       }
 
       getposts() {
         this.mservice.masbooth()
             .subscribe(
             resultArray => {
                 console.log('getdashcounts', resultArray);
                 this.arrpost = resultArray;
                
                 this.fmodel.boothid=resultArray[0].boothid;
                 this.getvotersboothwise();
             },
             error => console.log("Error :: " + error)
             )
       }
      
   
  
 
 



 updstatus(objcan) {
   debugger
  
   this.aservice.updvotstatus(objcan.voterid, objcan.rstatus)
        .subscribe(resultArray => {
           console.log('ret-loop', resultArray);
 //var cbclid=this.fmodel1,cbclid
           alert(resultArray.message);
           if(resultArray.status=='Success')
           {
             
          
         
           this.getvotersboothwise();
          
           }
           else
           {
              alert(resultArray.message);
           }
       }, error =>
           alert('error in connection')
       );
 }
   }
 
